import { render } from "./TungstenNetworkTable.vue?vue&type=template&id=f4a0a2ae&scoped=true"
import script from "./TungstenNetworkTable.vue?vue&type=script&lang=js"
export * from "./TungstenNetworkTable.vue?vue&type=script&lang=js"

import "./TungstenNetworkTable.vue?vue&type=style&index=0&id=f4a0a2ae&scoped=true&lang=less"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a0a2ae"]])

export default __exports__